export enum AccessRefType {
  ORGANISATION = 'ORG',
  USER = 'USER',
  STUDY = 'STUDY',
}
